import React from 'react'
import { useParams } from 'react-router-dom'

const withParams = WrappedComponent => {
  return props => {
    const params = useParams()
    const { pickupPersonId } = params

    return <WrappedComponent pickupPersonId={pickupPersonId} {...props} />
  }
}

export default withParams
